import React from "react";
import API from "@Src/api";
import jsonp from "jsonp";

export function useGetAttractions() {
  const [attractions, setAttractions] = React.useState(null);

  React.useEffect(() => {
    async function getAttractions() {
      try {
        const result = await API.attractions.fetchAllAttractions();
        setAttractions(result.data);
      } catch (error) {
        console.log("Error fetching attractions" + error);
        setAttractions([]);
      }
    }
    getAttractions();
  }, []);

  return attractions;
}

export function useGetStoreConfig() {
  const [storeConfig, setStoreConfig] = React.useState(null);

  React.useEffect(() => {
    async function getStoreConfig() {
      try {
        await jsonp(
          `${process.env.REACT_APP_STATIC_URL}/attraction_deals_config/storeMappings.jsonp`,
          {
            name: "sm_results",
          },
          (err, data) => {
            if (err) {
              console.error(err);
            } else {
              setStoreConfig(data);
            }
          },
        );
      } catch (error) {
        console.log("Error fetching Mappings" + error);
        setStoreConfig([]);
      }
    }
    getStoreConfig();
  }, []);

  return storeConfig;
}
